import applyMiddleware from '../../utils/route/applyMiddleware.js';
import requireRole from '../../utils/route/requireRole.js';
import Roles from '../../constants/Roles.js';

const audit = {
  name: 'audit',
  path: 'audit',
  onEnter: applyMiddleware(requireRole(Roles.AUDIT)),

  async getComponent() {
    const { AuditMain } = await import('./AuditRoutes');
    return AuditMain;
  },

  async getChildRoutes() {
    const { AuditRoutes } = await import('./AuditRoutes');
    return AuditRoutes;
  }
};

export default audit;



// WEBPACK FOOTER //
// ./src/apps/Audit/index.js